import React, { Fragment } from 'react';

import { ShortcutsSection } from '@confluence/space-shortcuts/entry-points/shortcutsSection';
import { SpaceViewsController } from '@confluence/space-views';
import { PageTreeLoaderOnHover } from '@confluence/page-tree';
import { BlogTree } from '@confluence/blog-tree/entry-points/BlogTree';

export const CommonSpaceNavigationContent = ({
	showShortcutsSection,
	space,
	spaceKey,
	quick,
	homepageId,
	loading,
	isSpaceAdmin,
	isBlogNavigation,
	blogsHidden,
	pageTreeFinishedLoading,
	onDragDropSuccess,
	onContentTreeLoadComplete,
}) => (
	<>
		{showShortcutsSection && (
			<ShortcutsSection
				isSpaceAdmin={isSpaceAdmin}
				spaceKey={spaceKey}
				links={quick}
				spaceId={space?.id || null}
			/>
		)}

		{!loading ? (
			// eslint-disable-next-line jsx-a11y/no-static-element-interactions
			<div
				data-vc="pageTree"
				data-testid="pageTree"
				onMouseEnter={PageTreeLoaderOnHover.hydrateOnHover}
			>
				<SpaceViewsController
					key={spaceKey} // Remount on space change to reset Space views state
					homepageId={homepageId}
					onDragDropSuccess={onDragDropSuccess}
					isPeekingFromBlogs={isBlogNavigation}
					onContentTreeLoadComplete={onContentTreeLoadComplete}
					spaceHasUserContent={space?.didContainUserContent}
				/>
			</div>
		) : (
			<Fragment />
		)}

		{!loading && !blogsHidden && (
			<BlogTree spaceKey={spaceKey} pageTreeFinishedLoading={pageTreeFinishedLoading} />
		)}
	</>
);
